import React from 'react';
const DashboardCards = () => {
  const cards = [{
    id: 1,
    title: 'Anzahl Lieferantenprofile',
    value: 197,
    color: 'border-l-4 border-l-green-500 bg-white'
  }, {
    id: 2,
    title: 'Lieferanten in Onboarding',
    value: 6,
    color: 'border-l-4 border-l-blue-500 bg-white'
  }, {
    id: 3,
    title: 'Offene Lieferantenbewertungen',
    value: 36,
    color: 'border-l-4 border-l-yellow-500 bg-white'
  }, {
    id: 4,
    title: 'Laufende Vergabeprojekte',
    value: 9,
    color: 'border-l-4 border-l-red-500 bg-white'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-53">
      {cards.map(card => <div key={card.id} className={`rounded shadow ${card.color} p-4`} data-id="element-54">
          <div className="text-2xl font-bold" data-id="element-55">{card.value}</div>
          <div className="text-xs text-gray-600" data-id="element-56">{card.title}</div>
        </div>)}
    </div>;
};
export default DashboardCards;